/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import firebase from 'firebase/app'
import 'firebase/auth'
import router from '@/router'
import axios from 'axios'
import { API_BASE_URL } from '@/constants'
import { ENDPOINT } from "../../constants/endpoint";
import Swal from "sweetalert2";

let highestRole = function (roles) {
    let ordered = {};
    ordered = roles.sort(function (a, b) {
        return (a.id) - (b.id);
    });
    return ordered[0].name;
}

export default {
    logout({ dispatch }) {
        localStorage.removeItem("accessUsername");
        localStorage.removeItem("userRole");
        localStorage.removeItem("accessToken");
        localStorage.removeItem("accessUserId");
        localStorage.removeItem("position");
        localStorage.removeItem("exciseType");
    },
    async login(context, payload) {
        const newPayload = {
            userDetails: payload.userDetails,
            notify: payload.notify,
            vm: payload.vm,
        };
        const username = payload.userDetails.username;
        const password = payload.userDetails.password;
        context.commit("LOADING", true);
        const url = ENDPOINT.LOGIN_URL;
        console.log(url);
        await axios
            .post(url, {
                username,
                password,
            })
            .then((res) => {
                console.log("res.data  ", res.data);
                if (res.data.user.roles.length == 1 && res.data.user.roles[0].name == "ROLE_USER") {
                    Swal.fire({
                        icon: "error",
                        title: "เข้าสู่ระบบไม่สำเร็จ",
                        text: "กรุณาตรวจสอบความถูกต้องอีกครั้ง",
                        showConfirmButton: false,
                        timer: 2500,
                    })
                } else {
                    console.log("this is check user ==> ", res.data.user.status);
                    if(res.data.user.status != 'ENABLED'){ 
                        Swal.fire({
                            icon: "error",
                            title: "เข้าสู่ระบบไม่สำเร็จ",
                            text: "กรุณาตรวจสอบความถูกต้องอีกครั้ง",
                            showConfirmButton: false,
                            timer: 2500,
                        }).then(() =>{ 
                            location.reload();
                        })
                    }else{ 
                    //login success
                        context.commit("LOGIN_SUCCESS", { data: res.data });
                        console.log("userRole >>>> ", localStorage.getItem('userRole'));

                        if (localStorage.getItem('userRole') == "ROLE_CONTRACTOR") {
                            router.push("/installationAccessories");
                        }else{
                            location.reload()
                        }
                    }
                }
            })
            .catch((error) => {
                // login fail
                Swal.fire({
                    icon: "error",
                    title: "เข้าสู่ระบบไม่สำเร็จ",
                    text: "กรุณาตรวจสอบความถูกต้องอีกครั้ง",
                    showConfirmButton: false,
                    timer: 2500,
                })
                context.commit("LOGIN_ERROR", { error });
            })
            .finally(() => {
                context.commit("LOADING", false);
            });
    },
    loginAttempt({ dispatch }, payload) {
        const newPayload = {
            userDetails: payload.userDetails,
            notify: payload.notify,
            vm: payload.vm
        }
        if (!payload.checkbox_remember_me) {
            // localStorage.setItem('remember_me', false);
            firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
                .then(function () {
                    dispatch('login', newPayload)
                })
                .catch(function (err) {
                    payload.notify({
                        time: 2500,
                        title: 'Error',
                        text: err.message,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
        } else {
            // localStorage.setItem('remember_me', true);
            dispatch('login', newPayload)
        }
    },


    // Google Login
    loginWithGoogle({ commit, state }, payload) {
        const provider = new firebase.auth.GoogleAuthProvider();
        firebase.auth().signInWithPopup(provider)
            .then((result) => {
                return result.user.getIdToken();
            })
            .then((idToken) => {

                axios.post(API_BASE_URL + 'auth/register',
                    {
                        idToken: idToken,
                        provider: "google"
                    })
                    .then(response => {
                        console.log(response);
                        let user = firebase.auth().currentUser;
                        if (user) {
                            user.getIdToken().then(function (data) {
                                console.log(data);
                                commit('UPDATE_AUTHENTICATED_USER', { userInfo: user.providerData[0], userRole: highestRole(response.data.roles), accessToken: idToken });
                                axios.get(API_BASE_URL + "api/me")
                                    .then(response => {
                                        localStorage.setItem('exciseUserInfo', JSON.stringify(response.data));
                                        // commit('UPDATE_USER_ROLE', highestRole(response.data.roles));
                                    })
                                    .catch(error => {
                                        console.log('Error getting user profile at login', error);
                                    });
                                return data;
                            })
                                .then(function (result) {
                                    console.log('zz', result);
                                    router.push(router.currentRoute.query.to || '/');
                                }, function (err) {
                                    console.log(err);
                                });
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });


            }).catch((err) => {
                payload.notify({
                    time: 2500,
                    title: 'Error',
                    text: err.message,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
    },

    // Facebook Login
    loginWithFacebook({ commit, state }, payload) {
        const provider = new firebase.auth.FacebookAuthProvider();

        firebase.auth().signInWithPopup(provider)
            .then((result) => {
                // console.log(JSON.stringify(result));
                // console.log(result);

                return result.user.getIdToken();
            })
            .then((idToken) => {

                axios.post(API_BASE_URL + 'auth/register',
                    {
                        idToken: idToken,
                        provider: "facebook"
                    })
                    .then(response => {
                        console.log(response);
                        let user = firebase.auth().currentUser;
                        if (user) {
                            user.getIdToken().then(function (data) {
                                console.log(data);
                                commit('UPDATE_AUTHENTICATED_USER', { userInfo: user.providerData[0], userRole: highestRole(response.data.roles), accessToken: idToken });
                                axios.get(API_BASE_URL + "api/me")
                                    .then(response => {
                                        localStorage.setItem('exciseUserInfo', JSON.stringify(response.data));
                                        // commit('UPDATE_USER_ROLE', highestRole(response.data.roles));
                                    })
                                    .catch(error => {
                                        console.log('Error getting user profile at login', error);
                                    });
                                return data;
                            })
                                .then(function (result) {
                                    console.log('zz', result);
                                    router.push(router.currentRoute.query.to || '/');
                                }, function (err) {
                                    console.log(err);
                                });
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });

            })
            .catch((err) => {
                payload.notify({
                    time: 2500,
                    title: 'Error',
                    text: err.message,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
    },

    // Twitter Login
    loginWithTwitter({ commit, state }, payload) {
        const provider = new firebase.auth.TwitterAuthProvider();
        firebase.auth().signInWithPopup(provider)
            .then((result) => {
                // console.log(JSON.stringify(result));
                // console.log(result);
                return result.user.getIdToken();
            })
            .then((idToken) => {
                axios.post(API_BASE_URL + 'auth/register',
                    {
                        idToken: idToken,
                        provider: "twitter"
                    })
                    .then(response => {
                        console.log(response);
                        let user = firebase.auth().currentUser;
                        if (user) {
                            user.getIdToken().then(function (data) {
                                console.log(data);
                                commit('UPDATE_AUTHENTICATED_USER', { userInfo: user.providerData[0], userRole: highestRole(response.data.roles), accessToken: idToken });
                                axios.get(API_BASE_URL + "api/me")
                                    .then(response => {
                                        localStorage.setItem('exciseUserInfo', JSON.stringify(response.data));
                                        // commit('UPDATE_USER_ROLE', highestRole(response.data.roles));
                                    })
                                    .catch(error => {
                                        console.log('Error getting user profile at login', error);
                                    });
                                return data;
                            })
                                .then(function (result) {
                                    console.log('zz', result);
                                    router.push(router.currentRoute.query.to || '/');
                                }, function (err) {
                                    console.log(err);
                                });
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });

            }).catch((err) => {
                payload.notify({
                    time: 2500,
                    title: 'Error',
                    text: err.message,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
    },

    updateAuthenticatedUser({ commit }, payload) {
        commit('UPDATE_AUTHENTICATED_USER', payload)
    },

    updateAuthenticatedUserToken({ commit }, payload) {
        commit('UPDATE_AUTHENTICATED_USER_TOKEN', payload)
    },
    // updateUserRole({ commit }, val) {
    //     commit('UPDATE_USER_ROLE', val);
    // }
}
